<template>
  <PolmedSpinner
    v-show="value || preserveSpace"
    :style="styles"
  ></PolmedSpinner>
</template>

<script>
export default {
  name: "Loading",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    preserveSpace: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    styles() {
      return {
        visibility: this.value ? "visible" : "hidden"
      };
    }
  }
};
</script>
